<template>
  <div class="st-box">
    <div class="traffic" @click="this.showStatuses = !this.showStatuses">
      <div
        class="traffic-light"
        :class="`traffic-light--${this.getColor(this.mainEdStatus)}`"
      ></div>
      <img
        class="arrow-status"
        :class="this.showStatuses ? 'arrow-status--up' : ''"
        src="@/assets/img/icons/arrow-down-status.svg"
        alt=""
        width="13"
        height="7"
      />
    </div>

    <ul
      class="ed-statuses-list"
      v-if="this.showStatuses"
    >
      <li
        v-for="(i, key) in this.edStInfodec"
        :key="key"
        class="ed-statuses-item"
        :class="`ed-statuses-item--${this.getColor(i.state)}`"
      >
        {{ i.name }}
      </li>
    </ul>
    <div
      v-if="this.showStatuses"
      class="edstatuses-outside"
      @click="this.showStatuses = false"
    ></div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "EdStatuses",
  data: () => ({
    edStInfodec: [],
    showStatuses: false,
    mainEdStatus: -1,
  }),
  mounted() {
    this.loadData();
    setInterval(this.loadData, 600000);
  },
  methods: {
    async fetchData() {
      try {
        const response = await axios.get("https://ping.infodec.ru/sv/get.php");
        this.edStInfodec = response.data.data;
        if (!Array.isArray(this.edStInfodec)) this.edStInfodec = [];
      } catch (error) {
        console.log(error);
      }
    },
    async loadData() {
      await this.fetchData();
      this.setTrafficColor();
    },
    setTrafficColor() {
      this.mainEdStatus = -1;
      if (this.edStInfodec.length === 0) return;

      this.edStInfodec.forEach((st) => {
        if (st.state > this.mainEdStatus) this.mainEdStatus = st.state;
      });
    },
    getColor(status) {
      switch (status) {
        case 0:
          return "green";
        case 1:
          return "yellow";
        case 2:
          return "red";
        default:
          return "";
      }
    },
  },
};
</script>


<style lang="scss">
.edstatuses-outside {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 1;
}
</style>

